// User Role Constants
export const USER_ROLES = {
  ADMIN: 'admin',
  USER: 'user'
};

// Article Constants
export const ARTICLE_STATUS = {
  PUBLISHED: 'published',
  DRAFT: 'draft',
  ARCHIVED: 'archived'
};

// Test Constants
export const TEST_DIFFICULTY = {
  EASY: 'Easy',
  INTERMEDIATE: 'Intermediate',
  ADVANCED: 'Advanced'
};

// PE Points Constants
export const PE_POINTS_VALUES = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 2.5, 3, 3.5, 4, 4.5, 5];

// Pagination Constants
export const ITEMS_PER_PAGE = 10;

// File Upload Constants
export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const ALLOWED_FILE_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/gif'
];

// API Constants
export const API_ENDPOINTS = {
  LOGIN: '/api/login',
  ARTICLES: '/api/articles',
  USERS: '/api/users',
  TESTS: '/api/tests',
  UPLOAD: '/api/upload'
};

// API Configuration
// export const API_BASE_URL = 'http://127.0.0.1:5000'; // For local development
// export const API_URL = 'http://127.0.0.1:5000/api'; // For local development
// export const API_BASE_URL = 'https://protagon-backend.vercel.app'; // For production
export const API_BASE_URL = 'https://api.protagon.ai';
export const API_URL = `${API_BASE_URL}/api`;

// Legacy constants needed by admin-frontend
export const PROFESSION_CATEGORIES = [
  'Accounting',
  'Valuation',
  'Tax',
  'Medicine',
  'Engineering',
  'Project Management',
  'Software Development',
  'Architecture',
  'Law',
  'Consulting',
  'Marketing',
  'Finance',
  'Education',
  'Research',
  'Business Analysis',
  'Data Science',
  'Other'
];

export const DIFFICULTY_LEVELS = [
  'Beginner',
  'Intermediate',
  'Advanced',
  'Expert'
];

export const PE_POINTS_OPTIONS = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 2.5, 3, 3.5, 4, 4.5, 5];

export const LANGUAGES = ['English', 'Dutch', 'German', 'Spanish'];

// Fallback image for articles without a specific image
export const FALLBACK_ARTICLE_IMAGE = 'https://images.unsplash.com/photo-1585829365295-ab7cd400c167?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80'; 